import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { UserEmailModelOutput } from 'infrastructure/graphql/content/user/model/user-email-model.output';

import { ApiQuery } from '../../../../common/model/api.query';

@Injectable({ providedIn: 'root' })
export class FetchUserEmailModelsApiQuery extends ApiQuery<
	UserEmailModelOutput[],
	void
> {
	client = 'content';
	document = gql`
		query FetchUserEmailModels {
			fetchUserEmailModels {
				id
				body
				name
				userId
				subject
			}
		}
	`;
	method = 'fetchUserEmailModels';
}
